module.exports = __webpack_public_path__ + "img/345a425.jpg";